webpackJsonp([81550533726015],{

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Container = __webpack_require__(9);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Header = __webpack_require__(13);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _website = __webpack_require__(8);
	
	var _website2 = _interopRequireDefault(_website);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint max-len: 0 */
	
	var Print = function Print() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Print | ' + _website2.default.siteTitle }),
	    _react2.default.createElement(_Header2.default, { slim: true, title: 'PRINT' }),
	    _react2.default.createElement(
	      'div',
	      { style: { marginTop: '3rem' } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Content'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Print Data ',
	          _react2.default.createElement('br', null),
	          'N/A ',
	          _react2.default.createElement('br', null),
	          'Unknown'
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = Print;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-print-jsx-aae5e5c81f1087cf44b9.js